
import { Group } from '../../types';
import { supabase, getCurrentUserId } from '../../supabase';
import { getGroups, setGroups } from './core';
import { handleApiError } from './api-utils';

export const fetchGroups = async (forceRemote = true): Promise<Group[]> => {
  try {
    // Only try remote if forceRemote is true
    if (forceRemote) {
      const userId = await getCurrentUserId();
      if (userId) {
        console.log('Fetching groups from Supabase...');

        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('Request timeout')), 5000)
        );

        const fetchPromise = supabase
          .from('groups')
          .select('*')
          .eq('user_id', userId);

        const { data, error } = await Promise.race([fetchPromise, timeoutPromise]) as any;

        if (error) {
          handleApiError(error, 'fetchGroups', 'Error fetching groups');
        } else if (data) {
          console.log(`Retrieved ${data.length} groups from Supabase`);
          
          const groups: Group[] = data.map(item => ({
            id: item.id,
            name: item.name,
            description: item.description,
            productIds: [], // Will be populated from product_groups
            createdAt: new Date(item.created_at),
            updatedAt: new Date(item.updated_at),
          }));

          try {
            const { data: productGroups, error: pgError } = await supabase
              .from('product_groups')
              .select('product_id, group_id');

            if (pgError) {
              handleApiError(pgError, 'fetchGroups', 'Error fetching product groups');
            } else if (productGroups) {
              groups.forEach(group => {
                group.productIds = productGroups
                  .filter(pg => pg.group_id === group.id)
                  .map(pg => pg.product_id);
              });
              console.log('Successfully populated group product relationships');
            }
          } catch (e: any) {
            handleApiError(e, 'fetchGroups', 'Error processing product groups');
          }

          setGroups(groups);
          return groups;
        }
      } else {
        console.log('No user ID available, falling back to localStorage');
      }
    }
    
    // Fall back to localStorage
    const localGroups = getGroups();
    console.log(`Retrieved ${localGroups.length} groups from localStorage`);
    return localGroups;
  } catch (error: any) {
    handleApiError(error, 'fetchGroups', 'Error in fetchGroups');
    return getGroups();
  }
};
